import styled, { css } from "styled-components";

const setBackgroundColor = (
  secondary: boolean,
  light: boolean,
  theme: { secondary: string; lightPurple: string; primary: string }
) => {
  if (secondary) {
    return theme.secondary;
  }
  if (light) {
    return theme.lightPurple;
  }
  return theme.primary;
};

const setColor = (
  secondary: boolean,
  light: boolean,
  theme: { secondary: string; text: string; body: string }
) => {
  if (secondary) {
    return "#fff";
  }
  if (light) {
    return theme.text;
  }

  return "#000";
};

const StyledButton = styled.button<{
  secondary?: boolean;
  active?: boolean;
  light?: boolean;
  disabled?: boolean;
}>`
  position: relative;
  width: 100%;
  height: 44px;
  max-width: 350px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ secondary, light, theme }) =>
    setBackgroundColor(secondary, light, theme.color)};
  color: ${({ secondary, light, theme }) =>
    setColor(secondary, light, theme.color)};
  cursor: pointer;
  font-weight: bold;
  border: none;
  border-radius: 8px;
  opacity: ${({ disabled }) => (disabled ? "0.5" : "1")};
  z-index: 2;

  ${({ active }) =>
    active &&
    css`
      background-color: ${({ theme }) => theme.color.darkPurple};
      color: #fff;
    `};
`;

export { StyledButton };
